/**
 * Stampa nell'area OSS. Nelle app native (window.OssApp) usa il servizio di stampa del sistema
 * (Android PrintManager, iOS AirPrint), perché nelle WebView window.print() e i popup di stampa
 * non funzionano. Nel browser resta il comportamento classico.
 *
 * Contratto del bridge (mobile/oss-android OssJsBridge.kt, mobile/oss-ios Production.swift):
 *   OssApp.print(title)              -> stampa la pagina corrente (@media print)
 *   OssApp.printPdf(title, dataUrl)  -> stampa un PDF (data:application/pdf;base64,...)
 *   OssApp.printHtml(title, html)    -> stampa un documento HTML autonomo (senza JS)
 */
import { blobToDataUrl, getOssBridge } from "./bridge";

const METHODS = { page: "print", pdf: "printPdf", html: "printHtml" };

export function canNativePrint(kind = "page", bridge = getOssBridge()) {
  const m = METHODS[kind];
  return Boolean(m && bridge && typeof bridge[m] === "function");
}

/** Stampa la pagina corrente. @returns {"native"|"browser"} */
export function printOssPage(title = "", { bridge = getOssBridge(), win = typeof window !== "undefined" ? window : null } = {}) {
  if (canNativePrint("page", bridge)) {
    bridge.print(String(title || (typeof document !== "undefined" ? document.title : "")));
    return "native";
  }
  if (win && typeof win.print === "function") win.print();
  return "browser";
}

/** Stampa un PDF (Blob) col bridge nativo. @returns {Promise<boolean>} false se il bridge non c'è (usare il fallback browser). */
export async function printOssPdf(blob, title = "", { bridge = getOssBridge() } = {}) {
  if (!canNativePrint("pdf", bridge) || !blob) return false;
  const pdf = blob.type === "application/pdf" ? blob : new Blob([blob], { type: "application/pdf" });
  bridge.printPdf(String(title || ""), await blobToDataUrl(pdf));
  return true;
}

/** Stampa HTML autonomo col bridge nativo. @returns {boolean} false se il bridge non c'è. */
export function printOssHtml(html, title = "", { bridge = getOssBridge() } = {}) {
  if (!canNativePrint("html", bridge) || !html) return false;
  bridge.printHtml(String(title || ""), String(html));
  return true;
}
